import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { FormattedDate } from 'components/intl'
import uuid from 'uuid'
import { get } from 'lodash'
import { Modal } from 'containers/misc'
import { TaskApprove, TaskReturn } from 'containers/forms/tasks'
import { AssessorReport } from 'containers/sections/assessors'
import { Table, Data } from 'components/layout/Table'
import { ButtonGroup, Button, BadgesLevels, Status } from 'components/misc'
import { TasksAwardLeaderNote } from 'components/sections/tasks'
import { tasks as tasksLayout } from 'constants/layout'
import { LEVELS, PROGRESS_STATES, ACTIVITY_SECTIONS } from 'constants/enums'
import config from 'config'
import TaskLogs from 'containers/forms/tasks/TaskLogs/TaskLogs'
import { FormattedMessage } from 'react-intl'
import styles from './tasks-sections-table.styl'

export default class TasksSectionsTable extends Component {
  static propTypes = {
    tasks: PropTypes.object.isRequired,
    list: PropTypes.array.isRequired,
    approveModal: PropTypes.func.isRequired,
    returnModal: PropTypes.func.isRequired,
    setSectionSignoffParams: PropTypes.func,
    modal: PropTypes.func.isRequired,
    setCommonLimit: PropTypes.func,
    isAssessorReportAdditionalInfoEnabled: PropTypes.bool.isRequired
  }

  constructor(props) {
    super(props)
    this.key = uuid.v1()
    this.state = {
      activityIdSignoff: null,
      activityIdReturn: null,
      note: '',
      activityId: null,
      activityActionId: null,
      activityAssessed: false,
      isAssessmentPositive: false,
      activity: null
    }
  }

  handleShowNote = note => {
    this.setState(
      {
        note
      },
      () => {
        this.props.modal(`modal-note-show-${this.key}`)
      }
    )
  }

  handleShowAssessorNote = (
    activityId,
    activityActionId,
    isAssessmentPositive
  ) => {
    this.setState(
      {
        activityId,
        activityActionId,
        isAssessmentPositive
      },
      () => {
        this.props.modal(`modal-assessor-note-show-${this.key}`)
      }
    )
  }

  handleApproveModal = activityIdSignoff => {
    this.setState(
      {
        activityIdSignoff
      },
      () => {
        this.props.modal(`modal-signoff-approve-${this.key}`)
      }
    )
  }

  handleLogModal = activity => {
    this.setState(
        {
          activity
        },
        () => {
          this.props.modal(`modal-show-logs-${this.key}`)
        }
    )
  }

  handleReturnModal = activityIdReturn => {
    this.setState(
      {
        activityIdReturn
      },
      () => {
        this.props.modal(`modal-signoff-return-${this.key}`)
      }
    )
  }

  handleMapRoute = awardLevelValue => {
    switch (awardLevelValue) {
      case LEVELS.BRONZE.value:
        return 'bronze-level'
      case LEVELS.SILVER.value:
        return 'silver-level'
      case LEVELS.GOLD.value:
        return 'gold-level'
      default:
        return 'detail'
    }
  }

  getActivitiesInSection = (award, activity) => {
    const section = get(activity, 'activitySection.value')

    const activityList = get(award, 'activities')

    return activityList.filter(a => get(a, 'activitySection.value') === section && get(a, 'activityState.value') !== PROGRESS_STATES.activityDeleted.id)
  }

  render() {
    const {
      tasks,
      list,
      tasks: { loading, offset, limit, pages, sort },
      setSectionSignoffParams,
      approveModal,
      returnModal,
      setCommonLimit,
      isAssessorReportAdditionalInfoEnabled
    } = this.props

    const tasksList = list || tasks.list

    return (
      <div>
        <Table
          loading={loading}
          length={tasksList.length}
          offset={offset}
          limit={limit}
          onSetLimit={setCommonLimit}
          pages={pages}
          sort={sort}
          ths={tasksLayout.sectionsApprovalTableHeaders}
          setParams={setSectionSignoffParams}
        >
          <Data>
            {tasksList.map(
              ({ id, activity = {}, award, note, participantPerson }) => (
                <tr key={id}>
                  <td>
                    <Link to={`${config.publicPath}/participants/${get(award, 'participant.id')}`}>
                      {get(award, 'participant.id')}
                    </Link>
                  </td>
                  <td>{get(participantPerson, 'firstName')}</td>
                  <td>{get(participantPerson, 'lastName')}</td>
                  <td>
                    <BadgesLevels levels={[award]} participantId={get(award, 'participant.id')} single />
                  </td>
                  <td>
                    {get(activity, 'completionDate') && (
                      <FormattedDate value={activity.completionDate} />
                    )}
                  </td>

                  <td>
                    <div>
                     { this.getActivitiesInSection(award, activity).map(
                        (a) => (
                             <div style={{ padding: '5px 0px 5px 5px' }}><Link
                                onClick={() =>
                                    this.handleLogModal(a)}
                                className="link"
                            >
                              {get(a, 'activityCategory.translatedName')}
                            </Link>
                               <br /></div>
                        ))}

                      <div className={styles.viewSectionWrapper}>
                      <Link
                          className={styles.viewSectionButton}
                          to={{
                            pathname: `${config.publicPath}/participants/${get(
                                award,
                                'participant.id'
                            )}/${this.handleMapRoute(
                                get(award, 'awardLevel.value')
                            )}`,
                            state: {
                              tabIndex:
                                  ACTIVITY_SECTIONS.ids[
                                      get(activity, 'activitySection.value')
                                      ].index || 0
                            }
                          }}
                      >
                        <FormattedMessage
                            id="button.view_section"
                            defaultMessage="View section"
                        />
                      </Link>
                     </div>
                    </div>
                  </td>
                  <td
                    className={
                      !get(activity, 'isAssessmentPositive')
                        ? 'text--center'
                        : ''
                    }
                  >
                    { this.getActivitiesInSection(award, activity).map(
                        (a) => (
                            <div style={{ padding: '5px 0px 5px 0px' }}>
                              {get(a, 'isAssessmentPositive') && (
                              <Button
                                  type="button"
                                  link
                                  onClick={() =>
                                      this.handleShowAssessorNote(
                                          get(a, 'id'),
                                          get(a, 'activityAssessmentActionId'),
                                          get(a, 'isAssessmentPositive')
                                      )
                                  }
                                  intlKey="button.view"
                              >
                                View
                              </Button>)}
                              <Status
                                  state={get(activity, 'isAssessmentPositive')}
                                  check
                                  inline
                                  toRight
                              />
                              <br /></div>
                        ))}
                  </td>
                  <td>
                    <Button
                      type="button"
                      link
                      intlKey="button.view"
                      onClick={() => this.handleShowNote(note)}
                    >
                      View
                    </Button>
                  </td>
                  <td className="text--center">
                    <ButtonGroup>
                      <Button
                        type="button"
                        onClick={() =>
                          this.handleApproveModal(get(activity, 'id'), {
                            isRp: false
                          })
                        }
                        intlKey="button.approve"
                        tiny
                      >
                        Approve
                      </Button>
                      <Button
                        type="button"
                        onClick={() =>
                          this.handleReturnModal(get(activity, 'id'), {
                            isRp: false
                          })
                        }
                        intlKey="button.revise"
                        tiny
                        secondary
                      >
                        Revise
                      </Button>
                    </ButtonGroup>
                  </td>
                </tr>
              )
            )}
          </Data>
        </Table>
        <Modal
          id={`modal-note-show-${this.key}`}
          closeAction="Close"
          intlKeyClose="modal.close"
        >
          <TasksAwardLeaderNote note={this.state.note} />
        </Modal>
        <Modal id={`modal-assessor-note-show-${this.key}`} closeAction="Close">
          <AssessorReport
            id={this.state.activityId}
            actionId={this.state.activityActionId}
            assessed={this.state.isAssessmentPositive}
            isActivity
            isAssessorReportAdditionalInfoEnabled={isAssessorReportAdditionalInfoEnabled}
          />
        </Modal>
        <Modal id={`modal-signoff-approve-${this.key}`} customActions>
          <TaskApprove
            approve={approveModal}
            id={this.state.activityIdSignoff}
            modal={this.props.modal}
          />
        </Modal>
        <Modal id={`modal-signoff-return-${this.key}`} customActions>
          <TaskReturn
            returnTask={returnModal}
            id={this.state.activityIdReturn}
            modal={this.props.modal}
          />
        </Modal>
        <Modal id={`modal-show-logs-${this.key}`} customActions>
          <TaskLogs
              activity={this.state.activity}
              modal={this.props.modal}
          />
        </Modal>
      </div>
    )
  }
}
